import { FirebaseError } from 'firebase/app';

import { showToast } from 'common';

export const useToast = () => {
  const showSuccess = (message: string) => {
    showToast('success', message);
  };

  const showError = (message: string) => {
    showToast('error', message);
  };

  const handleFirebaseError = (error: unknown) => {
    showToast('error', (error as FirebaseError).message);
  };

  const handleError = (error: unknown) => {
    showToast('error', (error as Error).message);
  };

  return { handleFirebaseError, handleError, showError, showSuccess } as const;
};
